export var HLS_HANDLER_FRIENDLY_NAME="HLS";